import React, { CSSProperties, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import PageLayoutNew from '../../../components/main/PageLayoutNew/PageLayoutNew';
import SpinnerNew from '../../../components/main/SpinnerNew/SpinnerNew';
import { useGetClientQuery } from '../../../generated/graphql';
import { ClientProvider } from '../Clients.Provider';
import ClientsRouting, { routes } from '../Clients.routing';

type ClientProps = {
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const Client = (props: ClientProps) => {
    const { style } = props;
    const { clientId } = useParams();
    const result = useGetClientQuery({
        variables: {
            id: clientId
        },
    });

    if (!result.data?.Client) {
        return <SpinnerNew size="large" label="Loading client..." />;
    }

    return (
        <PageLayoutNew
            routes={routes}
            pageName="Client Management"
            name={result.data.Client.name}
            backPath="/clients"
        >
            <ClientProvider client={result}>
                <ClientsRouting />
            </ClientProvider>
        </PageLayoutNew>
    );
};

export default Client;